const RecommendationsIcon = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			viewBox='0 0 32 32'
			fill='none'>
			<path
				d='M8.5 5.33337H22.5C23.9728 5.33337 25.1666 6.52728 25.1666 8.00004V24C25.1666 25.4728 23.9728 26.6667 22.5 26.6667H8.5C7.02724 26.6667 5.83331 25.4728 5.83331 24V8.00004C5.83331 6.52728 7.02724 5.33337 8.5 5.33337Z'
				stroke='#BF8AFC'
				strokeWidth='2'
			/>
			<path d='M10.5 11H20.5' stroke='#BF8AFC' strokeWidth='2' strokeLinecap='round' />
			<path d='M10.5 16H20.5' stroke='#BF8AFC' strokeWidth='2' strokeLinecap='round' />
			<path d='M10.5 21H17.5' stroke='#BF8AFC' strokeWidth='2' strokeLinecap='round' />
		</svg>
	);
};

export default RecommendationsIcon;
